<template>
  <div class="app">
    <div class="pay_head">
      <p class="pay_code">付款码</p>
      <p class="pay_show">结账时出示会员卡</p>
      <p class="pay_num" @click="clickT('2')">卡号密钥</p>
    </div>
    <div class="SweepBox" v-if="message == '1'">
      <div class="add">
        <longcode v-if="Bar" :onecode="1"></longcode>
      </div>
    </div>
    <div class="textBox" v-if="message == '2'">
      <p class="close_modal" @click="clickT('1')">X</p>
      <div style="padding-bottom: 5px; color: gray">
        <span>卡号</span>
        <span class="hui">{{ tateData.VIPNO }}</span>
      </div>
      <div style="padding-bottom: 5px; color: gray">
        <span>密钥</span>
        <span class="hui">{{ tateData.VeriFicationCode }}</span>
      </div>
    </div>
    <div class="mask" v-if="message == '2'"></div>
    <loading v-if="load"></loading>
  </div>
</template>
<script>
import Navigation from '@/components/Navigation'
export default {
  name: 'PaymentCode',
  data() {
    return {
      appcode: '',
      code: '',
      vipno: '',
      load: false,
      tateData: [],
      message: '1',
      Bar: false,
      Again: true,
      idx: 120,
    }
  },
  components: {
    Navigation,
  },
  mounted() {
    this.quer()
  },
  methods: {
    quer() {
      this.load = true
      this.appcode = localStorage.getItem('appcode')
      this.code = localStorage.getItem('code')
      this.vipno = localStorage.getItem('VIPNO')
      const companyID = localStorage.getItem('companyID')
      this.RequestVIP(
        `h5/vip/qrcode?openID=${this.code}&vipno=${this.vipno}&CompanyID=${companyID}`,
        (r) => {
          console.log(r, 'eeeeeeekekekekekek')
          this.tateData = r.data.data.table1[0]
          this.load = false
          localStorage.setItem('Barcode', this.tateData.Barcode)
          this.Bar = true
        },
        (err) => {
          this.load = false
          console.log(err)
          alert(err)
        }
      )
      // this.R(
      //   "queryPay",
      //   { appcode: this.appcode, code: this.code, vipno: this.vipno },
      //   r => {
      //     this.tateData = r.data.table1[0];
      //     this.load = false;
      //     localStorage.setItem("Barcode", this.tateData.Barcode);
      //     this.Bar = true;
      //   },
      //   err => {
      //     this.load = false;
      //     console.log(err);
      //     alert(err);
      //   }
      // );
    },
    clickT(val) {
      this.message = val
      // if (this.tateData == "") {
      //   this.quer();
      // }
    },
    clickAgain() {
      this.Again = !this.Again
      this.load = true
      this.appcode = localStorage.getItem('appcode')
      this.code = localStorage.getItem('code')
      this.vipno = localStorage.getItem('VIPNO')
      const companyID = localStorage.getItem('companyID')
      this.RequestVIP(
        `h5/vip/qrcode?openID=${this.code}&vipno=${this.vipno}&CompanyID=${companyID}`,
        // { appcode: this.appcode, code: this.code, vipno: this.vipno },
        (r) => {
          this.tateData = r.data.data.table1[0]
          this.load = false
          console.log(this.tateData.Barcode)
          localStorage.setItem('Barcode', this.tateData.Barcode)
          this.Bar = true
          let timer = setInterval(() => {
            this.idx -= 1
            if (this.idx == 0) {
              this.idx = 120
              clearTimeout(timer)
              this.Again = !this.Again
            }
          }, 1000)
        },
        (err) => {
          this.load = false
          console.log(err)
          alert(err)
        }
      )
      // this.R(
      //   "queryPay",
      //   { appcode: this.appcode, code: this.code, vipno: this.vipno },
      //   r => {
      //     this.tateData = r.data.table1[0];
      //     this.load = false;
      //     console.log(this.tateData.Barcode);
      //     localStorage.setItem("Barcode", this.tateData.Barcode);
      //     this.Bar = true;
      //     let timer = setInterval(() => {
      //       this.idx -= 1;
      //       if (this.idx == 0) {
      //         this.idx = 120;
      //         clearTimeout(timer);
      //         this.Again = !this.Again;
      //       }
      //     }, 1000);
      //   },
      //   err => {
      //     this.load = false;
      //     console.log(err);
      //     alert(err);
      //   }
      // );
    },
  },
}
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
  background: linear-gradient(317deg, #ff9c60 0%, #ff5a61 100%);
}

.pay_head {
  width: 100%;
  color: #fff;
  text-align: center;
  padding-top: 11px;
}

.pay_code {
  font-size: 13px;
  font-weight: bold;
  /* margin-top: 11px; */
}

.pay_show {
  font-size: 8px;
  margin-top: 8px;
}

.pay_num {
  width: 72px;
  height: 21px;
  border: 1px solid #ffffff;
  opacity: 1;
  border-radius: 50px;
  line-height: 21px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  margin-top: 11px;
  margin-left: 91.5px;
  background: url('/static/image/abag.png') 7px 4px no-repeat;
  background-size: 11px;
  padding-left: 5px;
}

.bottomNav {
  position: fixed;
  bottom: 0;
  height: 40px;
}

.SweepBox {
  border-radius: 6px;
  width: 94%;
  margin-left: 3%;
  padding-top: 17px;
  margin-top: 11px;
  box-shadow: 0px 0px 4px 0px #bdbdbd;
  background: #fff;
  height: 270px;
}

.swePayment {
  height: 35px;
  border-bottom: 0.5px solid #e0e0e0;
  line-height: 40px;
  font-size: 9px;
  color: #212121;
}

.sweleft {
  float: left;
  margin-left: 5%;
}

.sweright {
  float: right;
  margin-right: 5%;
  color: #ff6d55;
}

.add {
  width: 100%;
  height: 140px;
  background: #fff;
}

.textBox {
  width: 120px;
  height: 90px;
  background: #fff;
  border-bottom: 0.5px solid #e0e0e0;
  border-top: 0.5px solid #e0e0e0;
  font-size: 9px;
  color: #212121;
  position: fixed;
  top: 100px;
  left: 70px;
  padding: 10px 12px;
  box-sizing: border-box;
  z-index: 9999;
  border-radius: 5px;
}

.textBox > div {
  width: 95%;
  height: 30px;
  float: right;
  line-height: 30px;
}

.hui {
  color: #212121;
  margin-left: 20px;
  /* float: right;
  margin-right: 5%; */
}

.NavBox {
  background: #fff;
  height: 40px;
  width: 100%;
}

.nav {
  width: 50%;
  text-align: center;
  color: #212121;
  height: 40px;
  display: block;
  float: left;
  text-decoration: none;
}

.tu {
  height: 25px;
  line-height: 25px;
}

.iconfont {
  font-size: 22px;
}

.zi {
  height: 15px;
  line-height: 15px;
}

.zi > span {
  font-size: 8px;
}

.col {
  color: #46a1ff !important;
}

.close_modal {
  background: #ffffff;
  position: fixed;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50px;
  font-size: 20px;
  left: 110px;
  top: 225px;
}

.mask {
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/PaymentCode/index.vue